import { Component, OnInit } from "@angular/core";
import { ContentHeader } from "../../../layout/components/content-header/content-header.component";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseListDirective } from "../../../util/directives/base-list.directive";
import { ModalService } from "../../../util/service/modal.service";
import Swal from "sweetalert2";
import { colors } from "../../../colors.const";
import { EntityTyp } from "../../../util/enums/entity-typ.enum";
import { EmployeeService, OfficeService } from "app/api/services";
import { EmployeeListItemDto, OfficeNameDto } from "app/api/models";
import { UserRole } from "app/server/enums/user-role.enum";
import { AuthService } from "../../../util/service/auth.service";
import { ToastrService } from "ngx-toastr";
import { CaslAction } from "../../../server/enums/casl-action.enum";

@Component({
    selector: "app-employee-list",
    templateUrl: "./employee-list.component.html",
    styleUrl: "./employee-list.component.scss",
    standalone: false
})
export class EmployeeListComponent extends BaseListDirective<EmployeeListItemDto> implements OnInit {
  override modalType = EntityTyp.Employee;

  protected readonly UserRole = UserRole;
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;

  public contentHeader: ContentHeader;

  offices: OfficeNameDto[];

  constructor(
    protected override route: ActivatedRoute,
    protected override router: Router,
    private employeeService: EmployeeService,
    protected override modalService: ModalService,
    protected override fb: FormBuilder,
    private officeService: OfficeService,
    public authService: AuthService,
    private toastrService: ToastrService
  ) {
    super(fb, route, router, modalService);
  }

  ngOnInit(): void {
    this.offices = this.route.snapshot.data["offices"];

    this.contentHeader = {
      headerTitle: "Betreuer:innen",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Startseite",
            isLink: true,
            link: "/",
            translate: "MENU.HOME",
          },
          {
            name: "Betreuer:innen",
            isLink: false,
            translate: "MENU.EMPLOYEES",
          },
        ],
      },
    };

    this.initFilter({
      firstName: [null],
      lastName: [null],
      officeId: [null],
      deleted: [false],
    });
  }

  reload() {
    this.employeeService.employeeControllerFindAll(this.filter.value).subscribe({
      next: (page) => {
        this.page = page;
        this.syncPageNumber();
      },
    });
  }

  async openModal(id?: number) {
    await this.modalService.openEntityModal(EntityTyp.Employee, id);
    this.reload();
  }

  async delete(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diese:n Betreuer:in wirklich löschen?",
      icon: "error",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.danger,
      confirmButtonText: "Löschen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.employeeService.employeeControllerDelete({ id }).subscribe((res) => {
        this.toastrService.success("Erfolgreich gelöscht", "Erfolgreich gelöscht");
        this.reload();
      });
    }
  }

  async restore(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diese:n Betreuer:in wirklich wiederherstellen?",
      icon: "question",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.info,
      confirmButtonText: "Wiederherstellen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.employeeService.employeeControllerRestore({ id }).subscribe((res) => {
        this.toastrService.success("Erfolgreich wiederhergestellt", "Erfolgreich wiederhergestellt");
        this.reload();
      });
    }
  }
}
